import React, { useState } from 'react';
import { useIntl } from 'react-intl';
import {
  Collapse,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Tooltip,
} from '@mui/material';
import ArrowDown from '@mui/icons-material/KeyboardArrowDownRounded';
import PropTypes from 'prop-types';
import {
  ROUTE_ICONS,
  APP_ROUTES,
  ROUTES_PERMISSIONS,
} from '../../Router/routes';
import { StyledList } from '../../Theme/StyledComponents';

const RouteListItem = function RouteListItem({
  routeName,
  routePath,
  selected,
  icon = null,
  onClick,
  subRoutes,
  userRoles,
  sidebarOpen,
  isLongChannel,
  defaultOpen = false,
}) {
  const intl = useIntl();
  const [open, setOpen] = useState(defaultOpen);

  const isRouteAvailableForUser = Boolean(
    userRoles?.find(({ roleId }) =>
      ROUTES_PERMISSIONS[routeName]?.find(
        (permission) => permission?.toUpperCase() === roleId?.toUpperCase()
      )
    )
  );

  const toggleCollapsedList = () => {
    setOpen(!open);
  };

  return isRouteAvailableForUser ? (
    <>
      <ListItem
        sx={{
          padding: '0px 8px',
        }}
        secondaryAction={
          subRoutes && sidebarOpen ? (
            <ArrowDown
              sx={{
                transform: `rotate(${open ? 180 : 0}deg)`,
                transition: 'transform .5 ease-in-out',
              }}
            />
          ) : undefined
        }
      >
        <Tooltip
          title={!sidebarOpen ? intl.messages[routeName] : ''}
          placement="right"
        >
          <ListItemButton
            selected={selected === routePath}
            sx={{
              borderRadius: '8px',
              padding: sidebarOpen ? '8px 12px' : '8px',
            }}
            onClick={subRoutes ? toggleCollapsedList : () => onClick(routePath)}
          >
            <ListItemIcon sx={{ color: selected === routePath && '#fff' }}>
              {icon}
            </ListItemIcon>
            <ListItemText primary={intl.messages[routeName]} />
          </ListItemButton>
        </Tooltip>
      </ListItem>

      <Collapse in={open}>
        <StyledList sx={{ ml: sidebarOpen ? 2 : 0 }}>
          {subRoutes &&
            Object.keys(subRoutes)
              ?.filter((subRouteName) =>
                subRoutes[subRouteName]?.visible(isLongChannel)
              )
              ?.map((subRouteName) => {
                const subRouteObj = subRoutes[subRouteName];
                const subRoutePath = APP_ROUTES[subRouteName];
                const Icon = ROUTE_ICONS[subRouteName];

                return (
                  <RouteListItem
                    key={subRouteObj?.id}
                    routeName={subRouteName}
                    routePath={subRoutePath}
                    icon={<Icon />}
                    selected={selected}
                    onClick={onClick}
                    subRoutes={subRouteObj?.subRoutes}
                    userRoles={userRoles}
                    sidebarOpen={sidebarOpen}
                    isLongChannel={isLongChannel}
                    defaultOpen={subRouteObj?.defaultOpen}
                  />
                );
              })}
        </StyledList>
      </Collapse>
    </>
  ) : null;
};

RouteListItem.propTypes = {
  routeName: PropTypes.string,
  routePath: PropTypes.string,
  selected: PropTypes.number,
  icon: PropTypes.node,
  onClick: PropTypes.func,
  subRoutes: PropTypes.object,
  userRoles: PropTypes.array,
};

export default RouteListItem;
